import { useEffect, useState } from "react";

// The file `version.json` contains version information about the deployed application. 
// It is generated during the build process by the `run.sh` script on DEV, 
// and by the CI/CD pipeline on STAGE and PROD.


type VersionInfo = {
  deployed_at: string;
  git_commit: string;
  branch: string;
};

export default function ReleaseInfo() {
  const [version, setVersion] = useState<VersionInfo | null>(null);

  useEffect(() => {
    fetch("/version.json", { cache: "no-store" })
      .then((res) => res.json())
      .then(setVersion)
      .catch(() => setVersion(null));
  }, []);

  if (!version) return null;

  return (
    <small>
      {/*
        Release: {new Date(version.deployed_at).toLocaleString("de-AT")} ·{" "}
        {version.branch}@{version.git_commit}
      */}
      Release: {new Date(version.deployed_at).toLocaleString("de-AT")}
    </small>
  );
}